import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemService, OptionalService } from 'src/generated_client';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-optionals',
  templateUrl: './optionals.component.html',
  styleUrls: ['./optionals.component.css']
})

export class OptionalsComponent implements OnInit {

  allOptionals: Optional[] = [];
  checkedOptionals: Array<number> = [];
  itemId: number = 0;
  storeId: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Item,
    public optionalsService: OptionalService,
    public itemService: ItemService,
    private dialogRef: MatDialogRef<OptionalsComponent>,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit() {

    this.itemId = this.data.itemId;
    this.storeId = this.data.storeId;

    this.optionalsService.apiOptionalGetAllByStoreGet(this.storeId).subscribe(response => {

      response.forEach(o => {

        let opt: Optional = {

          cdOptional: Number(o.cdOptional),
          dsName: String(o.dsName),
          checked: this.data.Optionals.includes(Number(o.cdOptional))
        }

        this.allOptionals.push(opt)
      })
    })
  }

  getCheckedOptionals() {
    this.allOptionals.forEach(optional => {

      if (optional.checked) {
        this.checkedOptionals.push(optional.cdOptional)
      }
    });
  }

  saveChanges() {

    this.getCheckedOptionals();

    this.itemService.apiItemUpdateOptionalPost(this.checkedOptionals, this.itemId).subscribe(response => {
      this.dialogRef.close();
      this.router.navigate(['product-management']);
      this.snackBar.openSnackBar('Los cambios se guardaron correctamente','Aceptar')
    }, error => {
      this.snackBar.openSnackBar(error.error.error, 'Aceptar')
    })
  }
}

export interface Item {
  item: string,
  itemId: number,
  storeId: number,
  Optionals: Array<number>,
}

export interface Optional {
  cdOptional: number,
  dsName: string,
  checked?: boolean
}
